import { render, staticRenderFns } from "./Subhead.vue?vue&type=template&id=621887c2&scoped=true&"
import script from "./Subhead.vue?vue&type=script&lang=js&"
export * from "./Subhead.vue?vue&type=script&lang=js&"
import style0 from "./Subhead.vue?vue&type=style&index=0&id=621887c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621887c2",
  null
  
)

export default component.exports